import { App as AntdApp, ConfigProvider, DatePicker, Modal, Select, Tag, theme } from "antd";
import esES from "antd/locale/es_ES";
import { config } from "config";
import { AUTH_TOKEN, SISTEMA } from "constants/auth";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from "dayjs/plugin/utc";
import { useEffect } from "react";
import { Provider, useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { EnvProvider } from 'thegroup';
import './index.css';
import { store } from './redux/store';
import router from './router';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.tz.setDefault("America/Argentina/Buenos_Aires");

const token = localStorage.getItem(AUTH_TOKEN) || '';

const App = () => {
  const { defaultAlgorithm, darkAlgorithm, compactAlgorithm } = theme;
  const tema = useSelector(state => state.general.tema);
  const algorithms = [
    defaultAlgorithm,
    darkAlgorithm,
    compactAlgorithm,
  ];

  useEffect(() => {
    Modal.defaultProps = {
      maskClosable: false
    };
    Select.defaultProps = {
      notFoundContent: false
    };
    DatePicker.defaultProps = {
      format: "DD/MM/YYYY"
    };
    Tag.defaultProps = {
      className: "m-0",
    };
  }, []);

  return (
    <ConfigProvider
      locale={esES}
      theme={{
        algorithm: algorithms[tema],
        components: {
          Menu: {
            subMenuItemSelectedColor: tema === 1 ? "#fff" : "#2d3eb3",
            itemSelectedColor: tema === 1 ? "#fff" : "#2d3eb3",
          },
        },
        token: {
          colorPrimary: "#2d3eb3",
          colorFillAlter: tema === 0 ? '#f7f7f7' : '#1d1d1d',
        },
      }}
    >
      <AntdApp>
        <EnvProvider
          token={token}
          sistema={SISTEMA}
          config={config}
        >
          <RouterProvider router={router} />
        </EnvProvider>
      </AntdApp>
    </ConfigProvider>
  )
};

const AppWrapper = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppWrapper;
